import PageBreadcrumb from "../components/common/PageBreadCrumb";
import UserMetaCard from "../components/UserProfile/UserMetaCard";
import UserInfoCard from "../components/UserProfile/UserInfoCard";
import UserChangeEmailCard    from "../components/UserProfile/UserChangeEmailCard";
import UserChangePasswordCard from "../components/UserProfile/UserChangePasswordCard";
import DeleteUserCard from "../components/UserProfile/DeleteUserCard";
import { useStoreSelector } from "../hooks/useStoreFromContext";
import Spinner from "../components/ui/spinner";

import type { AppState } from '../store';

const UserProfiles = () => {
  const user = useStoreSelector((s: AppState) => s.user);

  if (!user) return <Spinner />;
  return (
    <>
      <PageBreadcrumb pageTitle="Profile" />
      <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] lg:p-6">
        <h3 className="mb-5 text-lg font-semibold text-gray-800 dark:text-white/90 lg:mb-7">
          Profile
        </h3>
        <div className="space-y-6">
          <UserMetaCard user={user} />
          <UserInfoCard user={user} />
          <UserChangePasswordCard user={user} />
          <UserChangeEmailCard />
          <DeleteUserCard user={user} />
        </div>
      </div>
    </>
  );
}

export default UserProfiles;
